import { Grid, Box } from '@mui/material';
import React, { useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import Checkbox from '../../Form/CheckBox';
import DeleteMembersModal from './DeleteMembersModal';

const AdditionalMembersTable = ({ additionalMembers, removeMembers }) => {
  const [selectedMembersIndex, setSelectedMembersIndex] = useState([]);
  const [showDeleteMembersModal, setShowDeleteMembersModal] = useState(false);

  const toggleSelectMember = (index) => {
    if (selectedMembersIndex.includes(index)) {
      setSelectedMembersIndex(selectedMembersIndex.filter((i) => i !== index));
    } else {
      setSelectedMembersIndex([...selectedMembersIndex, index]);
    }
  };

  const toggleSelectAll = () => {
    if (selectedMembersIndex.length === additionalMembers.length) {
      setSelectedMembersIndex([]);
    } else {
      setSelectedMembersIndex(additionalMembers.map((_, index) => index));
    }
  };

  const removeSelectedMembers = () => {
    // remove members from additionalMembers array
    removeMembers(selectedMembersIndex);

    // reset selectedMembersIndex
    setSelectedMembersIndex([]);
  };

  if (!additionalMembers?.length) return null;

  return (
    <>
      <Grid
        container
        gap={3}
        sx={{
          marginTop: {
            xs: '26px',
            md: '72px',
          },
        }}
      >
        <Grid item xs />
        <Grid item xs={12} md={10}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h5>Additional Members Information</h5>
            <div>
              <button
                className="btn-unstyled"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0 auto',
                  gap: '4px',
                  color: !selectedMembersIndex.length ? '#999999' : '#0a0a0a',
                }}
                type="button"
                disabled={!selectedMembersIndex.length}
                onClick={() => setShowDeleteMembersModal(true)}
              >
                <DeleteOutlineOutlinedIcon
                  sx={{
                    display: {
                      xs: 'none',
                      md: 'block',
                    },
                  }}
                />
                <span>Delete</span>
              </button>
            </div>
          </div>
          <table className="table-primary">
            <thead>
              <tr>
                <th>SN</th>
                <th>Name</th>
                <th>Age Range</th>
                <th>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.75rem',
                      margin: '0 auto',
                      flexDirection: {
                        xs: 'column',
                        md: 'row',
                      },
                    }}
                  >
                    <Checkbox
                      id="select-all"
                      onChange={toggleSelectAll}
                      checked={selectedMembersIndex.length === additionalMembers.length}
                    />
                    <label
                      style={{
                        fontWeight: '700',
                        textAlign: 'center',
                      }}
                      htmlFor="select-all"
                    >
                      Select all for deletion
                    </label>
                  </Box>
                </th>
              </tr>
            </thead>

            {/* Table body */}
            <tbody
              style={{
                textAlign: 'left',
              }}
            >
              {additionalMembers.map((member, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{member.name}</td>
                  <td>{member.ageRange}</td>
                  <td>
                    <Checkbox
                      onChange={() => toggleSelectMember(index)}
                      checked={selectedMembersIndex.includes(index)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
        <Grid item xs />
      </Grid>
      <DeleteMembersModal
        open={showDeleteMembersModal}
        onClose={() => setShowDeleteMembersModal(false)}
        onConfirmDelete={removeSelectedMembers}
      />
    </>
  );
};

export default AdditionalMembersTable;
